// extracted by mini-css-extract-plugin
module.exports = {"simpleLabel":"toolbarselects_simpleLabel__THvZk","choiceBoxes":"toolbarselects_choiceBoxes__1eTvH","simpleField":"toolbarselects_simpleField__pZ8K8"};